const $ = jQuery.noConflict();
import '@fancyapps/fancybox';
import Global from '../shared/global';

'use strict';
const Fancybox = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */


	/** @description Initialize */
	init: function() {
		this.fancyboxPopup('.js-popup-trigger', '.js-popup', 'popup-custom-class');
		this.fancyboxPopup('.js-pu-re-trigger', '.js-pu-re', 'popup-custom-class');
		this.fancyboxPopup('.js-footer-popup-trigger', '.js-footer-popup', 'popup-custom-class');
		// this.fancyboxPopup('.js-booked-popup-trigger', '.js-popup-thank-you', 'popup-custom-class');
		$(document).ready(function(){
			$('.js-close-popup').click(function(){
				$('.fancybox-close-small').click();
			});
		});
		Global.escKey(Fancybox.closeNoticePopup);
		// $(document).ready(function() {
		// 	if(localStorage.getItem('popState') !== 'shown') {
		// 		$('.js-notice-popup').delay(1000).addClass('is-active');
		// 		$('body').delay(1000).addClass('prevent-scroll');
		// 		localStorage.setItem('popState', 'shown');
		// 	}
		// });
		// $('.js-notice-popup__close').on('click', function() {
		// 	Fancybox.closeNoticePopup();
		// });
		// $('body').on('mouseup', function(e) {
		// 	e.preventDefault();
		// 	if ($('.js-notice-popup').hasClass('is-active') && !$('.js-notice-popup__inner').is(e.target) && $('.js-notice-popup__inner').has(e.target).length === 0) {
		// 		Fancybox.closeNoticePopup();
		// 	}
		// });
	},

	/**
	 * @description Fancy box custom popup functionality.
	 * @link documentation https://fancyapps.com/fancybox/3/docs/#inline
	 * @example this.functions.fancyboxPopup('.popup-btn', '.popup', 'my-custom-class');
	 * @param {string} trigger - popup trigger
	 * @param {string} popup - popup wrapper class
	 * @param {string} customClass - custom class for each popup (optional)
	 */
	fancyboxPopup: (trigger, popup, customClass = '') => {
		$(trigger).fancybox({
			src: popup,
			type: 'inline',
			smallBtn: true,
			baseClass: customClass
		});
	},

	// closeNoticePopup: function() {
	// 	$('.js-notice-popup').removeClass('is-active');
	// 	$('body').removeClass('prevent-scroll');
	// }
};

export default Fancybox;
